import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, Label, MessageStrip } from "@ui5/webcomponents-react";
import { useAuth } from "../../store/auth";

export default function LoginPage() {
  const navigate = useNavigate();
  const login = useAuth((s) => s.login);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch {
      setError("E-Mail oder Passwort ist falsch.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="logo" role="img" aria-label="Tennis">🎾</div>
          <h1>Calendery Admin</h1>
          <p>tennis-software.de · Terminverwaltung</p>
        </div>

        <form onSubmit={submit} style={{ display: "grid", gap: 16 }}>
          {error && <MessageStrip design="Negative" hideCloseButton>{error}</MessageStrip>}
          <div style={{ display: "grid", gap: 5 }}>
            <Label for="login-email">E-Mail</Label>
            <Input id="login-email" type="Email" value={email} style={{ width: "100%" }} onInput={(e) => setEmail(e.target.value)} />
          </div>
          <div style={{ display: "grid", gap: 5 }}>
            <Label for="login-password">Passwort</Label>
            <Input id="login-password" type="Password" value={password} style={{ width: "100%" }} onInput={(e) => setPassword(e.target.value)} />
          </div>
          <Button design="Emphasized" disabled={busy} onClick={submit} style={{ marginTop: 4 }}>
            {busy ? "Anmeldung…" : "Anmelden"}
          </Button>
        </form>
      </div>
    </div>
  );
}
